import { Component, OnInit } from '@angular/core';
import { AppSettingsService } from '../services/app-settings.service';

@Component({
  selector: 'app-navigation',
  templateUrl: './navigation.component.html',
  styleUrls: ['./navigation.component.css']
})
export class NavigationComponent implements OnInit {
showIcons: boolean;
assureLoginUrl = AppSettingsService.appSettings.AssureLoginUrl;

  constructor() { 
    this.showIcons = sessionStorage.getItem('token') == null ? false : true;}

  ngOnInit() {
  }

  redirectLogin() {
    window.location.href = this.assureLoginUrl
  }

}
